import React, { useState, useEffect } from "react";

import {
    Box,
    Button,
    ButtonGroup,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    MobileStepper,
    Modal,
    Paper,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

import tableIcons from "../tableFormatting/tableIcons";

const StudentWizard = () => {



return (
    <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ marginBottom: "30px" }}
    >
        <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
            
            <h2 style={{ marginBottom: "20px" }}>
                Content coming soon...
            </h2>
            <Button
                //  onClick={() => setAnalysisType("")}
                variant="outlined"
                //  component="label"
                style={{ float: "left", marginTop: "20px" }}
                >
            Back
            </Button>
            <Button
                //  onClick={() => onSubmit()}
                variant="outlined"
                //  component="label"
                style={{ float: "right", marginTop: "20px" }}
                >
            Next
            </Button>
            
        </div>
    </Grid>


    )
};


export default StudentWizard;